<template>
  <div class="pa-4 custome-border-component fixed-height-comp">
    <!-- Header -->
    <v-row class="page-header mt-0">
      <v-col class="page-title" cols="12">
        <v-toolbar-title class="font-bold custom-title">{{$t('lbl.admin.backup_file_finder')}}</v-toolbar-title>
      </v-col>
    </v-row>
    <!-- Condition search -->
    <v-row class="mb-0 custom-form-control admin-process-style custom-figma-1">
      <v-col cols="12" class="pt-0 pb-0 mb-0">
        <v-row>
          <v-col
            class="comm-header-col data-query-section pb-0 pt-0 mt-0 custom-field-combo custom-figma-1"
            cols="12"
            lg="4"
            md="12"
          >
            <v-row class="pt-0 pb-0 mt-0">
              <v-col cols="12" lg="6" md="12" class="pt-0 pb-0 mb-0">
                <div class="d-inline-flex-2 area-condition">
                  <v-text-field
                    v-model="fileContent"
                    @keyup.enter="searchData"
                    :label="$t('lbl.admin.file_content')"
                    dense
                    filled
                    class="custom-selectbox"
                  ></v-text-field>
                </div>
              </v-col>
              <v-col cols="12" lg="6" md="12" class="pt-0 pb-0 mb-0">
                <div class="d-inline-flex-2 area-condition">
                  <v-text-field
                    v-model="fileName"
                    @keyup.enter="searchData"
                    :label="$t('lbl.admin.file_name')"
                    dense
                    filled
                    class="custom-selectbox"
                  ></v-text-field>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col
            class="comm-header-col data-query-section custom-data-text pb-0 pt-0 mt-0 custom-figma-1"
            cols="12"
            lg="8"
            md="12"
          >
            <v-row class="pt-0 pb-0 mt-0">
              <v-col
                cols="12"
                lg="12"
                md="12"
                class="comm-header-col date-query-section pr-0 pb-0 pt-0 mt-0 custom-figma-1"
              >
                <div class="pl-0 pt-0 pb-0 d-inline-flex">
                  <v-menu
                    ref="fromdate_menu"
                    v-model="fromDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="fromDateData"
                        :placeholder="$t('lbl.common.fromDate',[dateTimeFormat])"
                        class="date-text-small"
                        append-icon="mdi-calendar"
                        dense
                        solo
                        @change="changeDate('from')"
                        @click:append="on.click"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="fromDateData"
                      :max="getMaxDate"
                      @input="fromDate = false; changeDate('from')"
                      class="date-period-picker"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="fromdate_menu = false">Cancel</v-btn>
                      <v-btn text color="primary" @click="$refs.fromdate_menu.save(fromDateData)">OK</v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
                <div class="pl-0 pt-0 pb-0 d-inline-flex">
                  <v-menu
                    ref="fromtime_menu"
                    v-model="fromTime"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="fromTimeData"
                        class="time-text"
                        append-icon="mdi-clock-outline"
                        dense
                        solo
                        @change="validateTimeInput('from')"
                        @click:append="on.click"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-model="fromTimeData"
                      class="time-picker"
                      format="ampm"
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="fromtime_menu = false"
                      >{{$t('btn.common.cancel')}}</v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.fromtime_menu.save(fromTimeData)"
                      >{{$t('btn.common.ok')}}</v-btn>
                    </v-time-picker>
                  </v-menu>
                </div>
                <div class="pl-0 pt-0 pb-0 d-inline-flex">
                  <v-menu
                    ref="todate_menu"
                    v-model="toDate"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="toDateData"
                        :placeholder="$t('lbl.common.toDate',[dateTimeFormat])"
                        class="date-text-small"
                        append-icon="mdi-calendar"
                        dense
                        solo
                        @change="changeDate('to')"
                        @click:append="on.click"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="toDateData"
                      :allowed-dates="allowedDates"
                      @input="toDate = false; changeDate('to')"
                      class="date-period-picker"
                      no-title
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="todate_menu = false"
                      >{{$t('btn.common.cancel')}}</v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.todate_menu.save(toDateData)"
                      >{{$t('btn.common.ok')}}</v-btn>
                    </v-date-picker>
                  </v-menu>
                </div>
                <div class="pl-0 pt-0 pb-0 d-inline-flex">
                  <v-menu
                    ref="totime_menu"
                    v-model="toTime"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="toTimeData"
                        class="time-text"
                        append-icon="mdi-clock-outline"
                        dense
                        solo
                        @change="validateTimeInput('to')"
                        @click:append="on.click"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-model="toTimeData"
                      class="time-picker"
                      format="ampm"
                      scrollable
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="totime_menu = false">Cancel</v-btn>
                      <v-btn text color="primary" @click="$refs.totime_menu.save(toTimeData)">OK</v-btn>
                    </v-time-picker>
                  </v-menu>
                </div>
                <div class="pl-0 pt-0 pb-0 d-inline-flex btn-control">
                  <v-btn
                    class="btn btn-top btn-search btn-width-1"
                    color="primary"
                    @click="searchData"
                  >
                    <v-icon x-small class="mr-2">fa fa-search</v-icon>
                    {{ $t("btn.common.search") }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <system-progress :sysloading="isLoading" :sysloadingTitle="sysloadingTitle"></system-progress>
      <v-col cols="12" class="pt-0 pb-0">
        <v-data-table
          :headers="headers"
          :items="listData"
          :class="['list-table admin-process-style srm-list-table custom-border-table', listData.length > 0 ? '' : 'custom-border-table-not-data']"
          :fixed-header="true"
          hide-default-footer
          :height="tableHeight"
          disable-pagination
          disable-sort
        >
          <template v-slot:item.fileContent="{ item}">
            <a
              class="link-file-text cursor-pointer layout-col"
              @click="openBackupFileContentView(item.fileContent, item)"
            >{{$t('btn.common.view')}}</a>
          </template>
          <template v-slot:item.requestTimestamp="{ item }">
            <font>{{applyGmtTimeZone(item.requestTimestamp)}}</font>
          </template>
          <template v-slot:item.processId="{ item }">
            <font
              class="link-file-text cursor-pointer layout-col"
              @click="openDetail(item)"
            >{{item.processId}}</font>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <div v-for="dialog in dialogs" :key="dialog.id" class="dialogs">
      <backupFileContentView
        v-if="dialog.type == 'backupFileContentView'"
        :id="dialog.id"
        :closeDialog="removeDialog"
        :dragEnd="dialogDragEnd"
        :dragStart="selectDialog"
        :move="dialogDragEnd"
        :options="dialog.options"
        :fileViewInfo="tempItem"
        :fileContent="outputFileContent"
      ></backupFileContentView>
    </div>
    <dialogWindow
      ref="DateValidation"
      :info="checkDialogTitle"
      size="max"
      :detail="$t('lbl.admin.date_validation')"
      :color="checkDialogColor"
      @select-ok="closeDialog()"
    ></dialogWindow>
    <dialogWindow
      ref="validateDate"
      size="max"
      :detail='$t("msg.common.validateDate")'
      color="validation"
    ></dialogWindow>
  </div>
</template>

<script>
import $ from "jquery";
import { resizeTableHeight } from "@/vue-dlb/common/common";
import { getAppliedTimeZone } from "@/vue-dlb/utils/util";
import { deleteDateFormatStr } from "@/vue-dlb/utils/util";
import config from "@/vue-caas/config/config.js";
import { mapState } from "vuex";
import dialogWindow from "@/vue-dlb/components/NewDialog.vue";
import SystemProgress from "@/vue-dlb/components/SystemProgress.vue";
import backupFileContentView from "@/vue-caas/views/admin/BackupFileContentView.vue";

const moment = require("moment");
export default {
  components: {
    dialogWindow,
    SystemProgress,
    backupFileContentView,
  },
  data() {
    return {
      isCreated: false,
      isLoading: true,
      fileContent: "",
      fileName: "",
      gmtTmzn: "",
      fromDate: false,
      fromDateData: getAppliedTimeZone(),
      fromTimeData: "00:00",
      fromTime: false,
      toTimeData: "23:59",
      toTime: false,
      dateTimeFormat: "",
      toDate: false,
      toDateData: getAppliedTimeZone(),
      listData: [],
      tableHeight: "",
      checkDialogTitle: "",
      checkDialogColor: "success",
      dialogs: [],
      arrLayoutDialog: [],
      dialogId: 1,
      dialog: false,
      outputFileContent: "",
      headers: [
        {
          text: "Owner ID",
          value: "groupId",
          width: "130px",
          sortable: false,
        },
        {
          text: "Company ID",
          value: "userId",
          width: "130px",
          sortable: false,
        },
        {
          text: "Process ID",
          value: "processId",
          width: "150px",
          sortable: false,
        },
        {
          text: "File Name",
          value: "fileName",
          width: "auto",
          sortable: false,
        },
        {
          text: "File Content",
          value: "fileContent",
          align: "center",
          width: "100px",
          sortable: false,
        },
        {
          text: "Date & Time",
          value: "requestTimestamp",
          width: "160px",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    validateDateInput(dateString) {
      var regEx = /^\d{4}-\d{2}-\d{2}$/;
      if(!dateString.match(regEx)) return false;  // Invalid format
      var d = new Date(dateString);
      var dNum = d.getTime();
      if(!dNum && dNum !== 0) return false; // NaN value, Invalid date
      return d.toISOString().slice(0,10) === dateString;
    },
    changeDate(side) {
      if (side === 'from') {
        if(!this.validateDateInput(this.fromDateData)) {
          this.$refs.validateDate.dialog = true;
          this.fromDateData = getAppliedTimeZone();
          this.toDateData = getAppliedTimeZone();
          return;
        }
        if (this.fromDateData > getAppliedTimeZone()) {
          this.fromDateData = getAppliedTimeZone();
        }
        if (this.fromDateData > this.toDateData) {
          this.toDateData = this.fromDateData
        }
      }
      if (side === 'to') {
        if(!this.validateDateInput(this.toDateData)) {
          this.$refs.validateDate.dialog = true;
          this.toDateData = getAppliedTimeZone();
          this.fromDateData = getAppliedTimeZone();
          return;
        }
        if (this.toDateData > getAppliedTimeZone()) {
          this.toDateData = getAppliedTimeZone();
        }
        if (this.fromDateData > this.toDateData) {
          this.fromDateData = this.toDateData
        }
      }
    },
    openDetail(item) {
      this.$emit("select-ok", item);
    },
    searchData() {
      this.isLoading = true;
      this.gmtTmzn = this.$cookies.get("gmt-timezone");
      const params = {
        fileContent: this.fileContent,
        fileName: this.fileName,
        fromDateData: this.applyGmtTimeZoneForSrchcond(
          this.fromDateData + " " + this.fromTimeData
        ),
        toDateData: this.applyGmtTimeZoneForSrchcond(
          this.toDateData + " " + this.toTimeData
        ),
        ownrId : this.$cookies.get("ownr-id"),
      };
      if (this.dateValidation(params.fromDateData, params.toDateData)) {
        this.$store
          .dispatch("getBackupFileFinderList", params)
          .then(() => {
            this.listData = this.$store.getters.backupFileFinderData;
            this.listData.map((e, i) => (e.INDEX = i));
            this.isLoading = false;
          })
          .catch((ex) => {
            this.isLoading = false;
          });
      } else {
        this.isLoading = false;
        this.$refs.DateValidation.dialog = true;
        this.checkDialogColor = "validation";
        this.checkDialogTitle = "Search";
        this.checkDialogInfo = this.$t("lbl.admin.date_validation");
      }
    },
    addDays(date, days) {
      let result = moment(date).add(days, "d").format("YYYY-MM-DD");
      return result;
    },

    applyGmtTimeZone(date) {
      let newM = "";
      if (date !== undefined && date !== "") {
        newM = moment
          .utc(date)
          .add(this.gmtTmzn, "hours")
          .format("YYYY-MM-DD HH:mm:ss");
      }
      return newM;
    },
    applyGmtTimeZoneForSrchcond(date) {
      let newM = "";
      if (date !== undefined && date !== "") {
        if (this.gmtTmzn.indexOf(`+`) === 0)
          newM = moment(date)
            .subtract(this.gmtTmzn, "hours")
            .format("YYYY-MM-DD HH:mm:ss");
        else if (this.gmtTmzn.indexOf(`-`) === 0)
          newM = moment(date)
            .add(this.gmtTmzn, "hours")
            .format("YYYY-MM-DD HH:mm:ss");
      }
      return newM;
    },
    dateValidation(frDat, toDat) {
      var dateDiff =
        (new Date(toDat.replace(/-/g, "/")) -
          new Date(frDat.replace(/-/g, "/"))) /
        (24 * 60 * 60 * 1000);
      if (dateDiff > 1 || dateDiff < 0) return false;
      else return true;
    },
    closeDialog() {
      this.$refs.DateValidation.dialog = false;
    },
    allowedDates(val) {
      let date = getAppliedTimeZone();
      if (val <= date) {
        return val;
      }
    },
    findDialog(id, dialogs) {
      if (!dialogs) dialogs = this.dialogs;
      let index = dialogs.findIndex((val) => {
        return val.id === id;
      });
      return index > -1 ? index : null;
    },
    newDialog(item, type) {
      return this.dialogs.push(this.generateDialog(item, type));
    },
    generateDialog(item, type) {
      let id = `${type}_${item.ROWID}`;
      this.arrLayoutDialog.push({ id: id });
      this.dialogId++;
      let name = "Dialog " + id;
      let options = { left: 30 * this.dialogId, top: 30 * this.dialogId, item };
      return { id, name, type, item, options };
    },
    selectDialog(obj) {
      let index = this.findDialog(obj.id);
      this.selected = this.dialogs[index];
    },
    dialogDragEnd(obj) {
      let index = this.findDialog(obj.id);
      this.$set(this.dialogs[index].options, "left", obj.left);
      this.$set(this.dialogs[index].options, "top", obj.top);
    },
    removeDialog(dialog) {
      let id = dialog.id;
      let index = this.findDialog(id);
      let indexArrDialog = this.findDialog(id, this.arrLayoutDialog);
      this.arrLayoutDialog.splice(indexArrDialog, 1);
      this.dialogs.splice(index, 1);
      if (this.selected && this.selected.id === id) this.selected = null;
    },
    openBackupFileContentView(outputFileContent, rowItem) {
      let type = "backupFileContentView";
      this.tempItem = rowItem;
      let item = {
        ROWID: 0,
        id: rowItem.INDEX.toString(),
        fileContent: outputFileContent,
      };
      let indexArrDialog = this.findDialog("backupFileContentView_0");
      if (indexArrDialog != null) {
        this.dialogs[indexArrDialog].options.item = item;
        return;
      }
      this.newDialog(item, type) - 1;
    },
  },
  created() {
    this.dateTimeFormat = config.dateTimeFormat;
    this.searchData();
    this.isCreated = true;
  },
  computed: {
    ...mapState("common", {
      sysloadingTitle: "sysloadingTitle",
    }),
    getMaxDate() {
      return getAppliedTimeZone();
    },
    getMinDate() {
      return this.fromDateData;
    },
  },
  updated: function () {
    let self = this;
    let arrClassMinus = [".page-control-content"];
    let arrClassPlus = [];

    if (this.isCreated) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 235 + "px";
      this.isCreated = false;
    }

    $(window).resize(function (event) {
      let h1 = resizeTableHeight(arrClassMinus, arrClassPlus, true);
      self.tableHeight = h1 + 235 + "px";
    });
  },
};
</script>